export default __webpack_public_path__ + "static/media/RedCrossIcon.02adcd53.svg";